export const ICE_SERVERS = [
  { urls: "stun:stun.l.google.com:19302" },
  {
    urls: [
      "turn:api.v2.vikingo-systems.com:443?transport=tcp",
      "turn:api.v2.vikingo-systems.com:3478?transport=udp",
      "turn:api.v2.vikingo-systems.com:3478?transport=tcp"
    ],
    username: "vikingo-rtc",
    credential: "bEvFVD0X6U1kiaO0FX4Fj75k"
  }
];
